import React from "react";
import * as S from "./Accordion.styles";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

type BaseRootProps = {
  /**
   * Children elements
   */
  children: React.ReactNode;

  /**
   * The type of accordion - "single" allows only one item to be open, while "multiple" allows multiple items to be open simultaneously.
   */
  type: "single" | "multiple";
};

type SingleAccordionProps = BaseRootProps & {
  type: "single";
  /**
   * The value of the item to expand (controlled).
   */
  value?: string;
  /**
   * Default value for uncontrolled component
   */
  defaultValue?: string;
  /**
   * Event handler called when the expanded state of an item changes.
   */
  onValueChange?: (value: string) => void;
  /**
   * When true, allows toggling an item to close it.
   */
  collapsible?: boolean;
};

type MultipleAccordionProps = BaseRootProps & {
  type: "multiple";
  /**
   * The value of the item to expand (controlled).
   */
  value?: string[];
  /**
   * Default value for uncontrolled component
   */
  defaultValue?: string[];
  /**
   * Event handler called when the expanded state of an item changes.
   */
  onValueChange?: (value: string[]) => void;
};

// Union type to handle both single and multiple types
export type AccordionRootProps = SingleAccordionProps | MultipleAccordionProps;

/**
 * Root component for Accordion
 */
export const AccordionRoot = (props: AccordionRootProps) => {
  const { children, ...restProps } = props;

  return <S.Root {...restProps}>{children}</S.Root>;
};
